<template>
    <div id="trans-filters" class="mb-1">
        <v-row>
            <!-- Enable other filters -->
            <v-col md="4">
                <v-select 
                    v-model="filter"
                    :items="filterOptions"
                    label="Filters"
                    multiple
                    dense
                    append-icon="mdi-filter-variant"
                    class="mt-0"
                    ><template
                        v-slot:selection="{ item, index }"
                        ><v-chip small v-if="index < 3">
                            <span>{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 3" class="grey--text caption">(+{{ filter.length - 3 }} others)</span>
                    </template>
                </v-select>
            </v-col>

            <!-- Transaction ID -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.transactionId"
                    append-icon="mdi-magnify"
                    label="Transaction ID"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.transactionId = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Status -->
            <v-col md="2">
                <v-select
                    v-model="search.status"
                    dense
                    :items="statusOptions"
                    label="Status"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- Card Holder -->
            <v-col md="2">
                <v-text-field
                    v-model="search.holder"
                    append-icon="mdi-magnify"
                    label="Card Holder"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.holder = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Bin -->
            <v-col md="2" v-if="filter.includes(2)">
                <v-text-field
                    v-model="search.bin"
                    append-icon="mdi-magnify"
                    label="BIN"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.bin = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Last 4 Digits -->
            <v-col md="2" v-if="filter.includes(6)">
                <v-text-field
                    v-model="search.last4Digits"
                    append-icon="mdi-magnify"
                    label="Last 4 Digits"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.last4Digits = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Merchant Transaction ID -->
            <v-col md="2" v-if="filter.includes(7)">
                <v-text-field
                    v-model="search.merchantTransactionId"
                    append-icon="mdi-magnify"
                    label="Merchant Transaction ID"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.merchantTransactionId = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Email Address -->
            <v-col md="2" v-if="filter.includes(4)">
                <v-text-field
                    v-model="search.email"
                    append-icon="mdi-magnify"
                    label="Email Address"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.email = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- IP Address -->
            <v-col md="2" v-if="filter.includes(5)">
                <v-text-field
                    v-model="search.ip"
                    append-icon="mdi-magnify"
                    label="IP Address"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.ip = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Payment Type -->
            <v-col md="2">
                <v-select
                    v-model="search.paymentType"
                    :items="paymentTypeOptions"
                    label="Payment Type"
                    multiple
                    dense
                    append-icon="mdi-filter-variant"
                    class="mt-0"
                    @change="searchTransactions"
                    ><template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index === 0">
                            <span>{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption">(+{{ search.paymentType.length - 1 }} others)</span>
                    </template>
                </v-select>
            </v-col>

            <!-- Payment Brand -->
            <v-col md="2" v-if="filter.includes(8)">
                <v-select
                    v-model="search.paymentBrand"
                    :items="paymentBrandOptions"
                    dense
                    label="Payment Brand"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- 3D Secure -->
            <v-col md="2" v-if="filter.includes(0)">
                <v-select
                    v-model="search.threeDSecure"
                    :items="threeDSecureOptions"
                    dense
                    label="3D Secure"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- Amount -->
            <v-col md="2" v-if="filter.includes(1)">
                <v-text-field
                    v-model="search.amount"
                    append-icon="mdi-magnify"
                    label="Amount"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.amount = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Recurring Type -->
            <v-col md="2" v-if="filter.includes(9)">
                <v-select
                    v-model="search.recurringType"
                    dense
                    :items="recurringTypeOptions"
                    label="Recurring Type"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- Clearing Institute -->
            <v-col md="2" v-if="filter.includes(3)">
                <v-select
                    v-model="search.clearingInstitute"
                    class="mt-0 pt-0"
                    dense
                    clearable
                    :items="clearingInstituteOptions"
                    item-text="name"
                    item-value="name"
                    label="Clearing Institutes"
                    append-icon="mdi-magnify"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- Result Code -->
            <v-col md="2" v-if="filter.includes(10)">
                <v-text-field
                    v-model="search.resultCode"
                    append-icon="mdi-magnify"
                    label="Result Code"
                    clearable
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                    @click:clear="search.resultCode = null; searchTransactions();"
                ></v-text-field>
            </v-col>

            <!-- Card Type -->
            <v-col md="2" v-if="filter.includes(11)">
                <v-select
                    v-model="search.cardType"
                    :items="cardTypeOptions"
                    dense
                    label="Card Type"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="searchTransactions"
                ></v-select>
            </v-col>

            <!-- From Date -->
            <v-col md="2">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        clearingInstituteOptions: Array,
        search: Object
    },
    data() {
        return {
            fromDateModal: false,
            toDateModal: false,
            filterOptions: [{ value: 0, text: '3D Secure' },
                            { value: 1, text: 'Amount' },
                            { value: 2, text: 'BIN' },
                            { value: 11, text: 'Card Type' },
                            { value: 3, text: 'Clearing Institute' },
                            { value: 4, text: 'Email Address' },
                            { value: 5, text: 'IP Address' },
                            { value: 6, text: 'Last 4 Digits' },
                            { value: 7, text: 'Merchant Transaction ID' },
                            { value: 8, text: 'Payment Brand' },
                            { value: 9, text: 'Recurring Type' },
                            { value: 10, text: 'Result Code' }],
            filter: [],
            statusOptions: [{ value: null, text: "All" },
                            { value: 0, text: "Failed" },
                            { value: 1, text: "Success" },
                            { value: 2, text: "Pending" }],
            paymentTypeOptions: [{ value: "3D", text: "3D" },
                                 { value: "AU", text: "Account Update"},
                                 { value: "CF", text: "Confirmation" },
                                 { value: "CP", text: "Capture" },
                                 { value: "CD", text: "Credit" },
                                 { value: "DB", text: "Debit" },
                                 { value: "DR", text: "Deregister" },
                                 { value: "DS", text: "Deschedule" },
                                 { value: "PA", text: "Pre-authorisation" },
                                 { value: "RF", text: "Refund" },
                                 { value: "RG", text: "Registration" },
                                 { value: "RR", text: "Reregister" },
                                 { value: "RS", text: "Reschedule" },
                                 { value: "RV", text: "Reversal" },
                                 { value: "SD", text: "Schedule" }],
            paymentBrandOptions: [{ value: null, text: "All" },
                                  { value: "AMEX", text: "AMEX" },
                                  { value: "BCMC", text: "BCMC" },
                                  { value: "CHINAUNIONPAY", text: "CHINAUNIONPAY" },
                                  { value: "DINERS", text: "DINERS" },
                                  { value: "DISCOVER", text: "DISCOVER" },
                                  { value: "JCB", text: "JCB" },
                                  { value: "MAESTRO", text: "MAESTRO" },
                                  { value: "MASTER", text: "MASTERCARD" },
                                  { value: "PAYSAFECARD", text: "PAYSAFECARD" },
                                  { value: "VISA", text: "VISA" },
                                  { value: "VISADEBIT", text: "VISADEBIT" },
                                  { value: "VISAELECTRON", text: "VISAELECTRON" }],
            threeDSecureOptions: [{ value: null, text: "All" },
                                  { value: 0, text: "Non 3D Secure" },
                                  { value: 1, text: "3D Secure" }],
            recurringTypeOptions: [{ value: null, text: "All" },
                                   { value: "INITIAL", text: "INITIAL" },
                                   { value: "REPEATED", text: "REPEATED" }],
            cardTypeOptions: [{ value: null, text: 'All'},
                              { value: 'credit', text: 'Credit'},
                              { value: 'debit', text: 'Debit'}]
        }
    },
    methods: {
        searchTransactions() {
            return this.$emit('search', this.search);
        },
        getClearingInstitutes() {
            axios({
            method: 'get',
            url: 'https://controlapi.totalprocessing.com/api/get-clearing-institutes',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.clearingInstituteOptions = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        handleDateFilters() {
            console.log(this.search.uuid);
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            return this.$emit('search', this.search);
        }
    }
}
</script>

<style>
    .v-chip.v-size--small {
        height: 20px;
    }

    #trans-filters .v-input__slot {
        margin-bottom: 0;
    }

    .v-text-field.v-input--dense:not(.v-text-field--outlined):not(.v-text-field--single-line) input {
        padding: 10px 0 2px;
    }
</style>